import { navSectionKeys } from "NavBar/navBarStore";

import { colors, navColors } from "UI/colors";

/**
 * Default colors (used when no navSectionKey specified)
 * Change these values to update ALL defaults globally
 */
export const DEFAULT_COLORS = {
  scrollbar: {
    color: "#617182", // default thumb color
    backgroundColor: "transparent", // default track color
  },
  loading: "#617182", // default loading carousel color
};

/**
 * NavSection-specific color configuration
 * Maps navigation section keys to their respective colors
 * Change these to update colors for specific sections
 *
 * Each section includes:
 * - scrollbar: colors for the custom scrollbar (thumb & track)
 * - loading: color for the loading carousel
 */
export const CATEGORY_COLORS = {
  [navSectionKeys.database]: {
    scrollbar: {
      color: navColors.database,
      backgroundColor: colors.transparent,
    },
    loading: navColors.database,
  },
  [navSectionKeys.giving]: {
    scrollbar: {
      color: navColors.giving,
      backgroundColor: colors.transparent,
    },
    loading: navColors.giving,
  },
  [navSectionKeys.groups]: {
    scrollbar: {
      color: navColors.communications,
      backgroundColor: colors.transparent,
    },
    loading: navColors.communications,
  },
  [navSectionKeys.tools]: {
    scrollbar: {
      color: navColors.tools,
      backgroundColor: colors.transparent,
    },
    loading: navColors.tools,
  },
  [navSectionKeys.signups]: {
    scrollbar: {
      color: navColors.signups,
      backgroundColor: colors.transparent,
    },
    loading: navColors.signups,
  },
  // Settings doesn't have a corresponding navSectionKey, but may be used
  settings: {
    scrollbar: {
      color: navColors.settings,
      backgroundColor: colors.transparent,
    },
    loading: navColors.settings,
  },
};
